import { render } from "./FarmerDashBenchmarkingChart.vue?vue&type=template&id=cb9e235e"
import script from "./FarmerDashBenchmarkingChart.vue?vue&type=script&lang=js"
export * from "./FarmerDashBenchmarkingChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__